import axios from 'axios';

/**
 * Centralized Axios instance with JWT token interceptor
 * Automatically adds Authorization header with Bearer token to all requests
 */

// Create axios instance
const axiosInstance = axios.create();

// Request interceptor to add Authorization header with JWT token
axiosInstance.interceptors.request.use(
    (config) => {
        // Get idToken from localStorage
        const idToken = localStorage.getItem('idToken');
        
        // If token exists, add Authorization header
        if (idToken) {
            config.headers['Authorization'] = `Bearer ${idToken}`;
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for handling 401 errors
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle 401 Unauthorized errors
        if (error.response && error.response.status === 401) {
            console.log('Token expired, refreshing page');
            // Reload page to trigger MSAL token refresh
            window.location.reload();
            return new Promise(() => {}); // Prevent error propagation
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
